import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["accountMenu"]

  toggleMenu() {
    this.accountMenuTarget.classList.toggle("flex-show")
  }
}
